// extracted by mini-css-extract-plugin
module.exports = {"logInButton":"style_logInButton__OvKZ3","loginIcon":"style_loginIcon__yPB0X","loginIconHover":"style_loginIconHover__E1npA"};